<template>
	<el-card class="foods">
		<div slot="header">食材</div>
		<el-button size="mini" type="primary" @click="handleAdd">
			新增
		</el-button>
		<el-table class="marginT10" :data="foods" border :key="key">
			<el-table-column type="index"></el-table-column>
			<el-table-column
				prop="foodsName"
				label="食材名称"
			></el-table-column>
			<el-table-column prop="usage" label="用量"></el-table-column>
			<el-table-column prop="meterage" label="计量"></el-table-column>
			<el-table-column
				prop="foodsUnit"
				label="计量单位"
			></el-table-column>
			<el-table-column
				prop="usageMethod"
				label="使用方法"
			></el-table-column>
			<el-table-column prop="address" label="操作">
				<template slot-scope="scope">
					<el-link
						type="primary"
						:disabled="scope.$index == 0"
						@click="handleMove('up', scope.$index)"
					>
						上移
					</el-link>
					<el-link
						type="primary"
						class="marginL10"
						@click="handleEdit(scope.$index)"
					>
						编辑
					</el-link>
					<el-link
						type="danger"
						class="marginL10"
						@click="handleDelete(scope.$index)"
					>
						删除
					</el-link>
					<el-link
						type="primary"
						class="marginL10"
						:disabled="scope.$index == foods.length - 1"
						@click="handleMove('down', scope.$index)"
					>
						下移
					</el-link>
				</template>
			</el-table-column>
		</el-table>
		<!-- 弹窗表单 -->
		<el-dialog
			:title="act == 'add' ? '添加食材' : '编辑食材'"
			:visible.sync="dialogVisible"
			:before-close="handleClose"
			width="50%"
			class="headRole"
		>
			<el-form
				ref="form"
				:model="form"
				:rules="foodsRule"
				label-width="120px"
			>
				<el-form-item label="食材名称" prop="foodsName">
					<el-input
						class="formInputShort"
						v-model="form.foodsName"
					></el-input>
				</el-form-item>
				<el-form-item label="用量" prop="usage">
					<el-input
						class="formInputShort"
						v-model="form.usage"
					></el-input>
				</el-form-item>
				<el-form-item label="计量" prop="meterage">
					<el-input-number
						class="formInputShort"
						:step="1"
						:precision="0"
						v-model.trim="form.meterage"
						:max="99999"
						:min="0"
					></el-input-number>
				</el-form-item>
				<el-form-item label="计量单位" prop="foodsUnit">
					<el-input
						class="formInputShort"
						v-model="form.foodsUnit"
					></el-input>
				</el-form-item>
				<el-form-item label="使用方法" prop="usageMethod">
					<el-input
						type="textarea"
						rows="3"
						style="width: 300px"
						v-model="form.usageMethod"
					></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="handleClose">取消</el-button>
					<el-button type="primary" @click="submitDialog">
						确认
					</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-card>
</template>

<script>
export default {
	props: ["foods", "idenList"],
	data() {
		// 字数限制-食材名称
		var checkFoodsName = (rule, value, callback) => {
			let len = 0,
				limit = JSON.parse(this.idenList.foodsName.bounds).size;
			if (this.idenList.foodsName.charcodec == "GBK") {
				len = this.$utils.getStrLengGBK(value);
			} else {
				len = this.$utils.getStrLengUTF8(value);
			}
			if (len > limit) {
				callback(
					new Error(
						"字数过长，字数限制：" +
							limit +
							"（" +
							this.idenList.foodsName.charcodec +
							"）"
					)
				);
			} else if (len < 1) {
				callback(new Error("请输入食材名称"));
			} else {
				callback();
			}
		};
		// 字数限制-食材用量
		var checkFoodsUsage = (rule, value, callback) => {
			let len = 0,
				limit = JSON.parse(this.idenList.usage.bounds).size;
			if (this.idenList.usage.charcodec == "GBK") {
				len = this.$utils.getStrLengGBK(value);
			} else {
				len = this.$utils.getStrLengUTF8(value);
			}
			if (len > limit) {
				callback(
					new Error(
						"字数过长，字数限制：" +
							limit +
							"（" +
							this.idenList.usage.charcodec +
							"）"
					)
				);
			} else if (len < 1) {
				callback(new Error("请输入食材用量"));
			} else {
				callback();
			}
		};
		// 字数限制-食材使用方法
		var checkFoodsMethod = (rule, value, callback) => {
			let len = 0,
				limit = JSON.parse(this.idenList.usageMethod.bounds).size;
			if (this.idenList.usageMethod.charcodec == "GBK") {
				len = this.$utils.getStrLengGBK(value);
			} else {
				len = this.$utils.getStrLengUTF8(value);
			}
			if (len > limit) {
				callback(
					new Error(
						"字数过长，字数限制：" +
							limit +
							"（" +
							this.idenList.usageMethod.charcodec +
							"）"
					)
				);
			} else {
				callback();
			}
		};
		return {
			dialogVisible: false,
			act: "",
			actIndex: "",
			key: Number(new Date()),
			form: {
				foodsName: "",
				usage: "",
				meterage: "",
				foodsUnit: "",
				usageMethod: "",
			},
			foodsRule: {
				foodsName: [{ validator: checkFoodsName, trigger: "blur" }],
				usage: [{ validator: checkFoodsUsage, trigger: "blur" }],
				usageMethod: [{ validator: checkFoodsMethod, trigger: "blur" }],
			},
		};
	},
	methods: {
		// 添加食材
		handleAdd: function () {
			this.act = "add";
			this.dialogVisible = true;
		},
		// 确认添加食材
		submitDialog: function () {
			this.$refs.form.validate((valid) => {
				if (valid) {
					let form = Object.assign({}, this.form),
						list = this.$utils.deepClone(this.foods);
					if (this.act == "add") {
						list.push(form);
					} else {
						list[this.actIndex] = form;
					}
					this.$emit("updateFoods", list);
					this.$refs.form.resetFields();
					this.dialogVisible = false;
				}
			});
		},
		// 移动食材
		handleMove: function (fun, idx) {
			let list = Object.assign([], this.foods),
				arr = this.$utils.handleMoveArr(list, fun, idx);
			this.$emit("updateFoods", arr);
		},
		// 编辑食材
		handleEdit: function (idx) {
			this.actIndex = idx;
			let obj = Object.assign({}, this.foods[idx]);
			this.act = "edit";
			this.dialogVisible = true;
			this.$nextTick((res) => {
				this.form = obj;
			});
		},
		// 取消添加食材
		handleClose: function () {
			this.$refs.form.resetFields();
			this.dialogVisible = false;
		},
		// 删除食材
		handleDelete: function (idx) {
			let msg = "确认删除此食材（" + this.foods[idx].foodsName + "）吗?",
				list = this.$utils.deepClone(this.foods);
			this.$confirm(msg, "提示", {
				confirmButtonText: "确认",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					list.splice(idx, 1);
					this.$emit("updateFoods", list);
				})
				.catch(() => {});
		},
	},
};
</script>

<style scoped>
</style>